/*
  global
  videojs
*/

import '../../app.es6';
import angular from 'angular';
import moment from '../../../node_modules/moment/moment.js';

const FILE_TYPE = 'video/mp4';
const VIDEO_DATE_FORMAT = 'YYYY年MM月DD日';

class MemberTopController {
  /* @ngInject */
  constructor (
    $scope, $rootScope, $sessionStorage, $location, $sce, $timeout,
    commonApiFactory, commonFactory, SharedState, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$sessionStorage = $sessionStorage;
    this.$location = $location;
    this.$sce = $sce;
    this.$timeout = $timeout;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    this.timestamp = new Date().getTime();

    // レッスン詳細でHeatmapを表示後、生徒トップでフラグを落とす
    this.$rootScope.heatmapFlg = false;
    // APIから取得したコースが存在している場合：true
    // APIから取得したコースが存在していない場合：false
    this.existenceFlg = true;
    // APIから取得したFBSが存在している場合：true
    // APIから取得したFBSが存在していない場合：false
    this.fbsExistenceFlg = false;
    // APIからのデータ取得が完了したか判定する
    this.getDataFin = false;

    this.UiSharedState = SharedState;

    let today = new Date();
    this.currentDate = today;
    let monthRange = this.commonFactory.getMonthRange(today);
    this.selectedYearMonth = moment().format('YYYY年M月');
    this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;

    this.feedbackSheets = [];
    this.selectedFbs = {};
    this.fbsIndex = 0;
    this.isFirstFbs = true;
    this.isLastFbs = true;

    this.videos = null;
    this.isVideosExist = false;
    this.videoRecDate = '';
    this.videoIndex = 0;
    this.isFirstVideo = true;
    this.isLastVideo = true;

    this.$timeout(() => {
      // ブラウザバックまたはブラウザフォワードでの遷移かつ、前のページが/member/lessonの場合、
      // レッスン詳細で表示していた月のレッスンリストを表示する
      if (this.$sessionStorage[this.Const.SSAPP_BROWSER_BACK_FORWARD] &&
          this.$sessionStorage[this.Const.SSAPP_OLD_LOCATION] === '/member/lesson') {
        today = new Date(this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE]);
        this.currentDate = today;
        monthRange = this.commonFactory.getMonthRange(today);
        this.selectedYearMonth = moment(this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE]).format('YYYY年M月');
        this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
      }
      if (localStorage.getItem(this.Const.LSAPP_ROLE) !== this.Const.LSAPP_ROLE_MEMBER) {
        this.staffLogic(monthRange);
      } else {
        this.memberLogic(monthRange);
      }
      this.loadFeedbackSheet();
      Page.setTitle(this.Const.TITLE.top);
    }, 0);

    MemberTopController.$inject = [
      '$scope', '$rootScope', '$sessionStorage', '$location', '$sce', '$timeout',
      'commonApiFactory', 'commonFactory', 'SharedState', 'Const', 'Page'
    ];
  }

  staffLogic (monthRange) {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    if (!this.$sessionStorage[this.Const.SSAPP_MEMBER_ID]) {
      this.$location.path('/staff/course');
    }
    let currentMemberId = this.$sessionStorage[this.Const.SSAPP_MEMBER_ID];

    let promises = [];

    // GET /members/{memberId}/lessons用
    let getMemberIdLessonsParams = {
      memberId: currentMemberId,
      endDateTime: monthRange.endDateParam,
      beginDateTime: monthRange.beginDateParam
    };

    let getMemberIdVideosParams = {
      memberId: currentMemberId,
      limit: '',
      beginDateTime: '',
      order: '',
      url: ''
    };

    promises.push(this.commonApiFactory.getMembersMemberIdLessons(getMemberIdLessonsParams));
    if (!this.videos) {
      promises.push(this.commonApiFactory.getMembersMemberIdVideos(getMemberIdVideosParams));
    }

    Promise.all(promises)
      .then((result) => {
        const [apiLessons, apiVideos] = result;
        this.lessonList = [];
        apiLessons.forEach((lesson) => {
          let main = [];
          let sub = [];
          for (let staff of lesson.course.staffs) {
            staff.type === this.Const.COACH_TYPE.main ? main.push(staff.name) : sub.push(staff.name);
          }
          let lessonObj = {
            startedDate: moment(lesson.startedDate).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
            endedDate: moment(lesson.endedDate).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
            date: moment(lesson.startedDate).format('M/D'),
            day: moment(lesson.startedDate).format('(ddd)'),
            beginTime: moment(lesson.startedDate).format('HH:mm'),
            endTime: moment(lesson.endedDate).format('HH:mm'),
            courseName: lesson.course.name,
            coachName: main.length === 0 ? '' : 'コーチ:' + main.join(','),
            subCoachName: sub.length === 0 ? '' : 'サブコーチ:' + sub.join(',')
          };
          this.lessonList.push(lessonObj);
        });
        if (this.lessonList.length) {
          this.existenceFlg = true;
          this.getDataFin = true;
          this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_LIST] = this.lessonList;
        } else {
          this.existenceFlg = false;
          this.getDataFin = true;
        }

        if (apiVideos) {
          let publicedVideos = [];
          apiVideos.forEach((video) => {
            if (video.state & this.Const.VIDEO_STATE_FLAG.publiced) {
              publicedVideos.push(video);
            }
          });
          this.setFirstVideo(publicedVideos);
        }
        this.$timeout(() => {
          this.commonFactory.overlayHidden();
        }, 2200);
        this.$scope.$apply();
      })
      .catch(() => {
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
      });
  }

  memberLogic (monthRange) {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    let promises = [];

    // GET /MembeerMeLessons 用 パラメータ
    let lessonParams = {
      beginDateTime: monthRange.beginDateParam,
      endDateTime: monthRange.endDateParam
    };

    let videoParams = {
      limit: '',
      beginDateTime: '',
      order: '',
      url: ''
    };

    promises.push(this.commonApiFactory.getMembersMeLessons(lessonParams));
    if (!this.videos) {
      promises.push(this.commonApiFactory.getMembersMeVideos(videoParams));
    }

    Promise.all(promises)
      .then((result) => {
        const [apiLessons, apiVideos] = result;
        this.lessonList = [];
        apiLessons.forEach((lesson) => {
          let main = [];
          let sub = [];
          for (let staff of lesson.course.staffs) {
            staff.type === this.Const.COACH_TYPE.main ? main.push(staff.name) : sub.push(staff.name);
          }
          let lessonObj = {
            startedDate: moment(lesson.startedDate).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
            endedDate: moment(lesson.endedDate).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
            date: moment(lesson.startedDate).format('M/D'),
            day: moment(lesson.startedDate).format('(ddd)'),
            beginTime: moment(lesson.startedDate).format('HH:mm'),
            endTime: moment(lesson.endedDate).format('HH:mm'),
            courseName: lesson.course.name,
            coachName: main.length === 0 ? '' : 'コーチ:' + main.join(','),
            subCoachName: sub.length === 0 ? '' : 'サブコーチ:' + sub.join(',')
          };
          this.lessonList.push(lessonObj);
        });
        if (this.lessonList.length) {
          this.existenceFlg = true;
          this.getDataFin = true;
          this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_LIST] = this.lessonList;
        } else {
          this.existenceFlg = false;
          this.getDataFin = true;
        }

        if (apiVideos) {
          this.setFirstVideo(apiVideos);
        }
        this.$timeout(() => {
          this.commonFactory.overlayHidden();
        }, 2000);
        this.$scope.$apply();
      })
      .catch(() => {
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
      });
  }

  loadFeedbackSheet () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    let currentMemberId = this.$sessionStorage[this.Const.SSAPP_MEMBER_ID];

    // GET /members/{memberId}/feedbackSheet用
    let getMemberIdFeedbackSheetParams = {
      memberId: currentMemberId
    };

    this.commonApiFactory.getMembersMemberIdFeedbackSheet(getMemberIdFeedbackSheetParams)
    .then((apiFeedbackSheet) => {
      this.fbsList = [];
      apiFeedbackSheet.fbs.forEach((fbs) => {
        let fbsObj = {
          periodName: fbs.periodName,
          pdfUrl: fbs.pdfUrl,
          fileName: fbs.fileName,
          periodStartDate: moment(fbs.periodStartDate).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
          isNew: fbs.isNew
        };
        this.fbsList.push(fbsObj);
      });

      if (this.fbsList.length) {
        this.fbsExistenceFlg = true;
        this.feedbackSheets = this.fbsList;
        this.setFirstFbs(this.feedbackSheets);
      } else {
        this.fbsExistenceFlg = false;
      }

      this.$timeout(() => {
        this.commonFactory.overlayHidden();
      }, 2200);
      this.$scope.$apply();
    })
    .catch((error) => {
      console.error(error);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  setFirstVideo (videos) {
    this.videos = [];
    videos.forEach((video) => {
      if (video.state & this.Const.VIDEO_STATE_FLAG.converted) {
        this.videos.push(video);
      }
    });
    // 最新の動画を最初に表示する
    this.videoIndex = this.videos.length - 1;

    if (this.$sessionStorage[this.Const.SSAPP_BROWSER_BACK_FORWARD] &&
        this.$sessionStorage[this.Const.SSAPP_VIDEO_ID]) {
      for (let i = 0; i < this.videos.length; i++) {
        if (this.$sessionStorage[this.Const.SSAPP_VIDEO_ID] === this.videos[i].id) {
          this.videoIndex = i;
        }
      }
    }

    if (this.videos.length === 0) {
      this.isVideosExist = false;
    } else if (this.videos.length >= 1) {
      this.isVideosExist = true;
      // check video is first video.
      if (this.videoIndex === 0) {
        this.isFirstVideo = true;
      } else {
        this.isFirstVideo = false;
      }
      // check video is last video.
      if (this.videoIndex === this.videos.length - 1) {
        this.isLastVideo = true;
      } else {
        this.isLastVideo = false;
      }
      this.videoRecDate = moment(this.videos[this.videoIndex].startedDate).format(VIDEO_DATE_FORMAT);
      let that = this;
      this.$timeout(() => {
        // 再生ボタンをダウンロード不可にする
        let el = document.getElementById(`video-play-button-${this.timestamp}`);
        el.addEventListener('contextmenu', (event) => {
          event.preventDefault();
        }, false);
        videojs(`video-${this.timestamp}`).ready(function () {
          let sources = [{'type': FILE_TYPE, 'src': that.$sce.trustAsResourceUrl(that.videos[that.videoIndex].getUrls.original)}];
          this.src(sources);
          let getUrls = that.videos[that.videoIndex].getUrls;
          if (getUrls && getUrls.thumb) {
            // サムネイル表示
            this.poster(getUrls.thumb);
          } else {
            this.load();
          }
        });
      }, 1000);
    }
  }

  setFirstFbs (feedbackSheets) {
    if (feedbackSheets.length > 1) {
      this.isFirstFbs = false;
    }
    // 初期表示は最新のFBS（配列の先頭の要素）
    this.selectedFbs = feedbackSheets[0];
  }

  changeVideo (action) {
    switch (action) {
      case 'next':
        this.videoIndex++;
        this.isFirstVideo = false;
        break;
      case 'back':
        this.videoIndex--;
        this.isLastVideo = false;
        break;
    }
    // サムネイルをリセット
    videojs(`video-${this.timestamp}`).poster('');
    if (this.videoIndex < 0 || this.videoIndex >= this.videos.length) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 3000, false);
    }
    if (this.videoIndex === 0) { this.isFirstVideo = true; }
    if (this.videoIndex === this.videos.length - 1) { this.isLastVideo = true; }

    this.videoRecDate = moment(this.videos[this.videoIndex].startedDate).format(VIDEO_DATE_FORMAT);
    let that = this;
    videojs(`video-${this.timestamp}`).ready(function () {
      let sources = [{'type': FILE_TYPE, 'src': that.$sce.trustAsResourceUrl(that.videos[that.videoIndex].getUrls.original)}];
      this.src(sources);
      let getUrls = that.videos[that.videoIndex].getUrls;
      if (getUrls && getUrls.thumb) {
        // サムネイル表示
        this.poster(getUrls.thumb);
      } else {
        this.load();
      }
    });
  }

  // 基準からみて次の月に該当するコースを表示する
  toNextMonth () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }

    this.getDataFin = false;
    let currentDate = this.currentDate;
    let nextMonthRnage = this.commonFactory.getMonthLater(currentDate);
    // 次の月を基準とする
    this.currentDate = new Date(nextMonthRnage.beginDateParam);
    this.selectedYearMonth = moment(this.currentDate).format('YYYY年M月');
    this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
    this.lessonList = [];
    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
      this.memberLogic(nextMonthRnage);
    } else {
      this.staffLogic(nextMonthRnage);
    }
  }

  // 基準からみて前の月に該当するコースを表示する
  tobeforeMonth () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }

    this.getDataFin = false;
    let currentDate = this.currentDate;
    let beforeMonthRnage = this.commonFactory.getMonthAgo(currentDate);
    // 前の月を基準とする
    this.currentDate = new Date(beforeMonthRnage.beginDateParam);
    this.selectedYearMonth = moment(this.currentDate).format('YYYY年M月');
    this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
    this.lessonList = [];
    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
      this.memberLogic(beforeMonthRnage);
    } else {
      this.staffLogic(beforeMonthRnage);
    }
  }

  // 次の期に該当するFBSを表示する
  toNextPeriod () {
    this.fbsIndex--;
    if (this.feedbackSheets.length - 1 >= this.fbsIndex) {
      this.selectedFbs = this.feedbackSheets[this.fbsIndex];
      this.isFirstFbs = false;
    }

    // 配列の先頭に辿り着いたら次の期に進むボタンを非表示にする
    if (this.fbsIndex === 0) {
      this.isLastFbs = true;
    }
  }

  // 前の期に該当するFBSを表示する
  tobeforePeriod () {
    this.fbsIndex++;
    if (this.feedbackSheets.length - 1 >= this.fbsIndex) {
      this.selectedFbs = this.feedbackSheets[this.fbsIndex];
      this.isLastFbs = false;
    }

    // 配列の最後尾に辿り着いたら前の期に戻るボタンを非表示にする
    if (this.feedbackSheets.length - 1 === this.fbsIndex) {
      this.isFirstFbs = true;
    }
  }

  toMemberLesson (lesson, idx) {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }

    this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX] =
    this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_INDEX] = idx;
    this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_LIST] = this.lessonList;
    if (this.$sessionStorage[this.Const.LSAPP_ROLE] === this.Const.LSAPP_ROLE_MEMBER &&
      this.$sessionStorage[this.Const.SSAPP_SENSOR_RENTAL] === this.Const.SENSOR_RENTAL.unRegistered) {
      this.UiSharedState.turnOn('dialogAdvertisePopup');
      return;
    }
    this.$sessionStorage[this.Const.SSAPP_LESSON_NAME] = lesson.courseName;
    this.$sessionStorage[this.Const.SSAPP_LESSON_DATE] = lesson.date;
    this.$sessionStorage[this.Const.SSAPP_LESSON_DAY] = lesson.day;
    this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE] = lesson.startedDate;
    this.$sessionStorage[this.Const.SSAPP_LESSON_END_DATE] = lesson.endedDate;
    this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_TIME] = lesson.beginTime;
    this.$sessionStorage[this.Const.SSAPP_LESSON_END_TIME] = lesson.endTime;
    this.$sessionStorage[this.Const.SSAPP_LESSON_COACH_NAME] = lesson.coachName;
    this.$sessionStorage[this.Const.SSAPP_LESSON_SUB_COACH_NAME] = lesson.subCoachName;
    this.$location.path('/member/lesson');
  }

  toVideoPlayScreen (urls) {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$sessionStorage[this.Const.SSAPP_VIDEO_ID] = this.videos[this.videoIndex].id;
    this.$sessionStorage[this.Const.SSAPP_PRESIGNED_URLS] = this.videos[this.videoIndex].getUrls;
    this.$sessionStorage['videoStartedDate'] = this.videos[this.videoIndex].startedDate;
    this.$sessionStorage['videoEndedDate'] = this.videos[this.videoIndex].endedDate;
    this.$location.path('/member/video');
  }
}

angular.module('myApp').controller('MemberTopController', MemberTopController);



// WEBPACK FOOTER //
// ./app/components/member-top/member-top-controller.es6